import { Delete, FileUpload } from '@mui/icons-material';
import { Box, Button, TextField, type BoxProps } from '@mui/material';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormFieldset } from 'src/shared/components/form/formFieldset';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { dataUrlToFile } from 'src/shared/functions/dataUrlToFile';
import { InvoiceGroup } from 'src/shared/models/invoiceGroup/invoiceGroup';
import { KivraCropImage } from './kivraCropImage';

const ImgBox = Box as React.ComponentType<BoxProps<'img'>>;

export const KivraImageUpload = () => {
  const { t } = useTranslation();

  const { setValue } = useFormContext();

  const [kivra] = useState<InvoiceGroup | undefined>();
  const [uploadedImageUrl, setUploadedImageUrl] = useState<string>('');
  const [uploadedImageFile, setUploadedImageFile] = useState<File | undefined>(undefined);
  const [croppedImage, setCroppedImage] = useState<File | undefined>(undefined);
  const [editMode] = useState<boolean>(false);

  const [cropDialogOpen, setCropDialogOpen] = useState(false);
  const [, setConfirmDeleteOpen] = useState<boolean>(false);

  //   const hasImages = event && event?.images?.length > 0;
  const hasImages = false;

  const onDeleteHandler = () => {
    setUploadedImageUrl('');
    setUploadedImageFile(undefined);
    setCroppedImage(undefined);
    setValue('iconBase64', '');
  };

  useEffect(() => {
    setValue('iconName', uploadedImageFile?.name || '');
  }, [setValue, uploadedImageFile]);

  // const onDeleteHandlerEditMode = useCallback(async () => {
  //   try {
  //     // await deleteEventImageById(event?.images[0].id);
  //     if (isMounted()) {
  //       toast.success(<>{t('event:imageDeleted')}</>);
  //       if (kivra) {
  //         setKivra({ ...kivra, kivraImage: [] });
  //       }
  //     }
  //   } catch (error) {
  //     if (isMounted()) ConsoleHelper.log('error', error);
  //   }
  // }, [kivra, isMounted, setKivra, t]);

  const handleChange = (e) => {
    setUploadedImageUrl(URL.createObjectURL(e.target.files[0]));
    setUploadedImageFile(e.target.files[0]);
    setCropDialogOpen(true);

    // if (hasImages) {
    //   onDeleteHandlerEditMode();
    // }
  };

  return (
    <>
      <FormFieldset legend={t('invoice:adminInvoiceGroupDetailPage.imageHeader')} fullHeight={!hasImages} childrenTop={uploadedImageUrl.length > 0}>
        <Box sx={{ pt: 1, px: 0.5, pb: 0 }}>
          {editMode && kivra && (
            <>
              {!hasImages && !uploadedImageFile && (
                <Button variant='outlined' component='label' size='small' sx={{ mb: 1 }} endIcon={<FileUpload fontSize='small' />}>
                  {t('invoice:adminInvoiceGroupDetailPage.chooseImage')}
                  <Box sx={{ display: 'none' }}>
                    <TextField
                      hidden
                      type='file'
                      inputProps={{
                        hidden: true,
                        accept: 'image/*',
                      }}
                      onChange={(e) => handleChange(e)}
                      sx={{}}
                    />
                  </Box>
                </Button>
              )}
              {hasImages && (
                <>
                  <ImgBox
                    component='img'
                    sx={{ height: 'auto', width: '100%', borderRadius: 1 }}
                    // src={`data:image/png;base64,${event?.images?.[0].base64}`}
                    alt={t('invoice:adminInvoiceGroupDetailPage.kivraImageAltText')}
                  />
                  <Button variant='outlined' size='small' endIcon={<Delete />} onClick={() => setConfirmDeleteOpen(true)}>
                    {t('common:button.remove')}
                  </Button>
                </>
              )}
              {uploadedImageUrl && uploadedImageFile && (
                <>
                  <ImgBox
                    component='img'
                    src={uploadedImageUrl}
                    alt={t('invoice:adminInvoiceGroupDetailPage.kivraImageAltText')}
                    sx={{ width: '100%', maxHeight: '100%', objectFit: 'cover', objectPosition: 'bottom', m: 0, p: 0 }}
                  />
                  <Button variant='outlined' size='small' endIcon={<Delete />} onClick={onDeleteHandler}>
                    {t('common:button.remove')}
                  </Button>
                </>
              )}
            </>
          )}
          {!editMode && (
            <>
              <Button variant='outlined' component='label' size='small' sx={{ mb: 1 }} endIcon={<FileUpload fontSize='small' />}>
                {t('invoice:adminInvoiceGroupDetailPage.chooseImage')}
                <Box sx={{ display: 'none' }}>
                  <TextField
                    hidden
                    type='file'
                    inputProps={{
                      hidden: true,
                      accept: 'image/*',
                    }}
                    onChange={(e) => handleChange(e)}
                    sx={{}}
                  />
                </Box>
              </Button>

              {uploadedImageUrl && croppedImage && (
                <ImgBox
                  component='img'
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  src={croppedImage as any}
                  alt={t('invoice:adminInvoiceGroupDetailPage.kivraImageAltText')}
                  sx={{ width: '100%', maxHeight: '100%', objectFit: 'cover', objectPosition: 'bottom', m: 0, p: 0 }}
                />
              )}
              {uploadedImageFile && (
                <Button variant='outlined' size='small' endIcon={<Delete />} onClick={onDeleteHandler}>
                  {t('common:button.remove')}
                </Button>
              )}
            </>
          )}
        </Box>
      </FormFieldset>
      <KivraCropImage
        open={cropDialogOpen}
        image={uploadedImageUrl}
        onComplete={(imagePromise) => {
          ConsoleHelper.log('onComplete', imagePromise);
          imagePromise.then((image) => {
            setValue('iconBase64', image);
            setUploadedImageFile(dataUrlToFile(image, 'kivraIcon.png'));
            setUploadedImageUrl(image);
            setCroppedImage(image);
            setCropDialogOpen(false);
          });
        }}
        onAbort={() => {
          onDeleteHandler();
          setCropDialogOpen(false);
        }}
      />
      {/* <GenericDialog
        maxWidth='xs'
        open={openConfirmDelete}
        showDividers={false}
        saveLabel={t('common:button.yes')}
        abortLabel={t('common:button.no')}
        dialogTitle={t('event:confirm')}
        dialogContent={t('event:wantToRemoveImage')}
        onClose={() => setConfirmDeleteOpen(false)}
        onSave={() => {
          setConfirmDeleteOpen(false);
          onDeleteHandlerEditMode();
        }}
      /> */}
    </>
  );
};
